import Text from 'components/3catinfo/Text';
import styles from '../contingutEstatic.module.scss';

const TextComponent = (props) => {
    const { text } = props;
    return <Text text={text} dataTestId='contingut-parsejat-text' className={styles.text} />;
};

export default TextComponent;
